import { CreditDebitIndicator, BookedObjectType, StatementFilters } from "./Types";
import { FieldConfig } from "../../utils/GenericFilters";
import { FieldTypes } from "@vwpfs/mary-air-lib/components/air/07-organisms";

/**
 *
 */
export const CreditDebitIndicatorTypeDisplay: Readonly<Record<CreditDebitIndicator, string>> = {
    [CreditDebitIndicator.CRDT]: "Credit",
    [CreditDebitIndicator.DBIT]: "Debit",
};

/**
 *
 */
export const BookedObjectTypeDisplay: Readonly<Record<BookedObjectType, string>> = {
    [BookedObjectType.CLAIM_INVOICE]: "Claim Invoice",
    [BookedObjectType.COLLECTIVE_INVOICE]: "Collective Invoice",
    [BookedObjectType.EXCASSO]: "Excasso",
    [BookedObjectType.INCASSO]: "Incasso",
    [BookedObjectType.PARTNER_INVOICE]: "Partner Invoice",
    [BookedObjectType.GENERAL_LEDGER_INVOICE]: "General Ledger Invoice",
};

/**
 * Unified field configuration for Statement filters
 * Everything in one place - labels, types, and field-specific validation!
 */
export const StatementFilterFieldsConfig: Record<keyof StatementFilters, FieldConfig> = {
    creationDate: {
        label: "Creation date",
        type: FieldTypes.Date,
    },
    mutationDate: {
        label: "Mutation date",
        type: FieldTypes.Date,
    },
    stmtId: {
        label: "Statement ID",
        type: FieldTypes.Text,
    },
    accountId: {
        label: "Account ID",
        type: FieldTypes.Text,
    },
};
